"use strict";

import gsap from "gsap";
import CustomEase from "gsap/CustomEase";

const heroOutAnimation = (container) => {
	const image = container.querySelector(".hero__image");
	const introEls = container.querySelectorAll(".hero__text .intro span");
	const aboutEls = container.querySelectorAll(".hero__text .about--short > *");

	gsap.registerPlugin(CustomEase);

	const breakPoint = gsap.matchMedia();
	const tl = gsap.timeline({
		defaults: {
			duration: 1,
			ease: CustomEase.create("custom", "M0,0 C0.069,1 0.458,1 1,1 "),
		},
		onComplete: () => {
			return false;
		},
	});

	breakPoint.add("(max-width: 1024px)", () => {
		tl.to(introEls, { yPercent: -100, stagger: 0.1 })
			.to(introEls, { opacity: 0, ease: "none", duration: 0.2 }, "<")
			.to(aboutEls, { yPercent: -200, stagger: 0.1 }, 0)
			.to(aboutEls, { opacity: 0, duration: 0.2, ease: "none" }, "<")
			.to(
				image,
				{
					scale: 50,
					duration: 1,
					ease: "power2.in",
				},
				"<"
			)
			.to(image, { opacity: 0, ease: "none", duration: 0.2 }, "<0.2")
			.to(container, { autoAlpha: 0 }, "<");
	});

	breakPoint.add("(min-width: 1025px)", () => {
		tl.to(introEls, { xPercent: -100, stagger: 0.1 })
			.to(introEls, { opacity: 0, ease: "none", duration: 0.2 }, "<")
			.to(aboutEls, { yPercent: -200, stagger: 0.1 }, 0)
			.to(aboutEls, { opacity: 0, duration: 0.2, ease: "none" }, "<")
			.to(
				image,
				{
					scale: 50,
					duration: 1,
					ease: "power2.in",
				},
				"<"
			)
			.to(image, { opacity: 0, ease: "none", duration: 0.2 }, "<0.2")
			.to(container, { autoAlpha: 0 }, "<");
	});

	return tl;
};

export default heroOutAnimation;
